import React from 'react';

import AdminCardOrderField from '../admin-card-fields/AdminCardOrderField/AdminCardOrderField';
import AdminCardImage from '../admin-card-fields/AdminCardImage/AdminCardImage';
import AdminCardField from '../admin-card-fields/AdminCardField/AdminCardField';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import './AdminProductCard.css';

const AdminProductCard = ({
  product,
  onEditClickHandler,
  onDeleteClickHandler,
}) => {
  const productFields = [
    { label: 'Product Name:', value: product.name, type: 'text' },
    {
      label: 'Product Description:',
      value: product.description,
      type: 'textarea',
    },
  ];

  return (
    <div className='product__list'>
      <div className='admin-product-card-top-container'>
        <AdminCardOrderField>{product?.order}</AdminCardOrderField>
        <div className='admin-product-edit-delete-button-container'>
          <ContentChangeButton
            iconType='edit'
            onClickHandler={() => onEditClickHandler(product)}
          />
          <ContentChangeButton
            iconType='delete'
            onClickHandler={() => onDeleteClickHandler(product)}
          />
        </div>
      </div>
      <div className='admin-edit-content-container'>
        <div className='product-picture-container'>
          <AdminCardImage size='large' img={product.imageUrl} />
        </div>
        <div className='admin-product-btns-fields-container'>
          <div className='product__group'>
            {productFields.map((field, i) => (
              <AdminCardField key={i} label={field.label} type={field.type}>
                {field.value}
              </AdminCardField>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProductCard;
